/**
 * Thin fetch wrapper around `GET /v1/me/entitlements`. Reuses the shared API
 * base + Firebase ID-token + TransformInterceptor unwrapping conventions
 * (mirrors `modules/analytics/api.ts`). The page consumes this through the
 * `usePublishEntitlement` hook so React never sees fetch shapes directly.
 */
import { API_BASE } from '@/src/infrastructure/lib/api';
import { auth } from '@/src/infrastructure/config/firebase';
import type { PublishEntitlementView } from './types';

async function authFetch<T>(url: string): Promise<T> {
  const token = await auth.currentUser?.getIdToken().catch(() => null);
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message ?? `HTTP ${res.status}`);
  }
  const body = await res.json();
  return (body?.data !== undefined ? body.data : body) as T;
}

export function fetchPublishEntitlement() {
  return authFetch<PublishEntitlementView>(`${API_BASE}/me/entitlements`);
}
